import {returnBylocalStorageData,saveBylocalStorage} from "./storage";
//获取token
export function getToken(){
	var token=returnBylocalStorageData("DES_BOOTSTRAP_TOKEN");
	if(token){
		return token;
	}else{
		return "";
	}
}
export function setToken(token){
	saveBylocalStorage("DES_BOOTSTRAP_TOKEN",token);
}
//这里需要根据应用返回Application的code
export function getApplicationCode(){
	var appCode=returnBylocalStorageData("DES_BOOTSTRAP_APPLICATION");
	if(appCode){
		return appCode;
	}else{
		return "auth";
	}
}
//写入
export function setApplicationCode(code){
	if(!code){
		saveBylocalStorage("DES_BOOTSTRAP_APPLICATION",'auth');
	}else{
		saveBylocalStorage("DES_BOOTSTRAP_APPLICATION",code);
	}
	
}
